import { Injectable } from '@angular/core';
import { SafeDrivingService } from './safe-driving.service';
import { AuthHttp, AuthHttpError } from 'angular2-jwt';
import { AppConfig } from '../../../app.config';

@Injectable()
export class WidgetMachineService {

  constructor(private safeDrivingService: SafeDrivingService, private authHttp: AuthHttp, private appConfig: AppConfig) { }

  get(endPoint) {
    const serverUrl = this.appConfig.getValue('endPoint');
    return this.authHttp.get(serverUrl + 'templatedrivenwidget/' +  endPoint.toLowerCase()).toPromise();
  }

  removeSafeDriving() {
    return this.safeDrivingService.removeSafeDrivingExpiry();
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/services/widget-machine.service.ts